export const repairAnalysisInfo = {
  headline: "Your file has been repaired.",
  numberOfFlippedPolygons: "Flipped normals:",
  numberOfRemovedFlatOpenShells: "Planar sheets removed:",
  numberOfClosedOpenLoops: "Holes fixed:",
  numberOfMergedVertexPairs: "Vertex pairs merged:",
  repairPictureHeadline: "Repairs done:",
  repairPictureControls: "Please have a look at all sides of the model to check for all the repairs done (significant changes highlighted in red).",
  fileIsReadyForPrinting: "Your file is ready for printing now. Please have a look at the changes made. See the image above or download the repaired file.",
  downloadFile: "Download",
  continue: "Close",
}